import { Component, Input , OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './inventory-management.component.html',
  styleUrls: ['./inventory-management.component.scss'],
})
export class InventoryManagementComponent implements OnInit {

 @Input() product_id;
 inventory
  constructor(public db:DataService,public modalCtrl:ModalController) { }

  ngOnInit() {
    // this.get_values();  
  }


  // get_values(){
  //   this.db.get_inventory_values(data).subscribe(r=>{
  //       let data = r['data'];
  //       this.inventory = data.find(r => r.product == this.product_id);
  //       console.log(this.inventory)
  //   })
  // }


  

}
